<markant-platform-ui-card
  class="management-tile"
  [headline]="'cartridge.management.serviceResponsibility.title' | transloco"
>
  <h5>{{ serviceManager }}</h5>
  <p>{{ 'cartridge.management.serviceResponsibility.message' | transloco }}</p>

  @if (showEditButton()) {
    <div footer>
      <a class="link" (click)="openDialog()">
        <markant-icon
          icon="m_edit"
          slot="icon-leading"
          disabled="true"
        ></markant-icon>
        {{ 'cartridge.management.serviceResponsibility.edit' | transloco }}
      </a>
    </div>
  }
</markant-platform-ui-card>

<ng-container
  *ngIf="
    showDialog && isAuthorized && (serviceManagers$ | async) as serviceManagers
  "
>
  <!-- DIALOG TO SELECT SERVICE MANAGER -->
  <markant-platform-service-responsibility-dialog
    *ngIf="serviceManagers.length && showDialog"
    [isLoading]="isLoading"
    [data]="serviceManagers"
    [serviceManager]="serviceManager"
    (saved)="onSave($event)"
    (closed)="onCloseDialog()"
  >
  </markant-platform-service-responsibility-dialog>

  <!-- DIALOG TO SHOW WARNING FOR NO SERVICE MANAGERS AVAILABLE -->
  <markant-platform-modal-bridge *ngIf="!serviceManagers.length">
    <markant-platform-approve-dialog
      class="dialog no-members-dialog"
      [open]="showDialog"
      [closeOnApprove]="true"
      [headline]="
        'cartridge.management.serviceResponsibility.dialog.noUsers.title'
          | transloco
      "
      [text]="
        (isPlatformAdmin
          ? 'cartridge.management.serviceResponsibility.dialog.noUsers.message.pfa'
          : 'cartridge.management.serviceResponsibility.dialog.noUsers.message.oa'
        ) | transloco
      "
      [approveButtonText]="
        'cartridge.management.serviceResponsibility.dialog.addOrganisationAdmin'
          | transloco
      "
      [cancelButtonText]="'general.abort' | transloco"
      (openChange)="onCloseDialog()"
      (isApproved)="goToMembersView()"
    >
    </markant-platform-approve-dialog>
  </markant-platform-modal-bridge>
</ng-container>

<markant-platform-modal-bridge *ngIf="!isAuthorized && showDialog">
  <!-- DIALOG TO SHOW WARNING UNAUTHORIZED -->
  <markant-platform-info-dialog
    *ngIf="showDialog"
    class="dialog unauthorised-dialog"
    [open]="true"
    [headline]="
      'cartridge.management.serviceResponsibility.dialog.notAuthorized.title'
        | transloco
    "
    [text]="
      'cartridge.management.serviceResponsibility.dialog.notAuthorized.message'
        | transloco
    "
    [buttonText]="'general.close' | transloco"
    (submitChange)="onCloseDialog()"
    (openChange)="onCloseDialog()"
  >
  </markant-platform-info-dialog>
</markant-platform-modal-bridge>
